import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss']
})
export class RadioButtonComponent {
  @Input() id: string;
  @Input() name: string;
  @Input() value: number;
  @Input() label: string;
  @Input() isChecked: boolean;

  @Output() selectionChanged = new EventEmitter<number>();

  onChange(event: Event): void {
    this.selectionChanged.emit(this.value);
  }
}
